import classNames from 'classnames';
import { Glyphicon } from 'react-bootstrap';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Loading extends PureComponent {
  constructor(props) {
    super(props);
    this.handleDisplay = this.handleDisplay.bind(this);
    this.state = {
      delaying: !!props.delay
    }
  }

  componentDidMount() {
    if (this.props.delay) {
      this.timeout = setTimeout(this.handleDisplay, this.props.delay)
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  handleDisplay() {
    this.timeout = null
    this.setState({delaying: false})
  }

  render() {
    let {delay, inline, text} = this.props;
    let {delaying} = this.state;
    let className = classNames('Loading', {
      'Loading--delaying': delaying,
      'Loading--displaying': delay && !delaying,
      'Loading--inline': inline
    });

    return <div className={className}>
      <Glyphicon glyph="refresh"/>
      {text && <div className="Loading__text">{text}&hellip;</div>}
    </div>
  }

};

Loading.propTypes = {
  delay: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number
  ]),
  inline: PropTypes.bool,
  text: PropTypes.string
};

Loading.defaultProps = {
  delay: 500,
  inline: false
};

export default Loading;